import { Count } from '../types';

export const mapQuestionnaireCountResponse = (data: Count) => ({
	count: data.count,
});
